import React from 'react';
import AppShell from '@hydra/common/shell/AppShell';

import CrawlerRoutes from './crawler';
import SerpRoutes from './serp';
import TrafficRoutes from './traffic';
import { OverviewRoutes, OptimizeRoutes, HomeRoutes } from './overview';
import AuditRoutes from './audit';
import CreateRoutes from './create';
import ReviewRoutes from './review';
import ReviewChangesRoutes from './review-changes';
import PdfEditorRoutes from './pdf-editor';
import PdfRoutes from './pdf';
import OnpageAdvisorRoutes from './onpage-advisor';
import MarketingChecklist from './marketing-checklist';
import CoreWebVitals from './core-web-vitals';
import Keywords from './keywords';
import KeysRoutes from './keys';
import LeadsRoutes from './leads';
import PagesRoutes from './pages';
import DashboardRoutes from './dashboard';
import AuthenticationRoutes, { LogInRoutes, SignupRoutes } from './authentication';
import SettingsRoutes from './settings';
import SubscriptionRoutes from './subscription';
import GARoutes from './oauth/ga';
import GSCRoutes from './oauth/gsc';
import FBRoutes from './oauth/fb';
import AssistantRoutes from './assistant';
import AccountRoutes, { PaymentRoutes, CancelPlanRoutes } from './account';
import PricingRoutes from './pricing';
import PastdueRoutes from './pastdue';
import SuspiciousRoutes from './suspicious';
import TrialEnded from './trial-ended';
import ShopifyRoutes from './shopify';
import { IntegrationDudaRoutes, IntegrationWebflowRoutes } from './integrations';
import CompleteSubscriptionRoutes from './complete-subscription';

import { ErrorGeneric } from '@hydra/common/error';

/* Generic 404 route */
export const NotFound = ({
  path: '*',
  render: ({ props }) => {
    const error = { statusCode: 404, message: 'Not found' };
    return <ErrorGeneric error={error} {...props} />;
  }
});

export default () => ([
  {
    path: '/shopify',
    Component: AppShell,
    children: [
      ShopifyRoutes
    ]
  },
  {
    path: '/:lang',
    Component: AppShell,
    children: [
      PdfRoutes,
      OnpageAdvisorRoutes,
      MarketingChecklist,
      CoreWebVitals,
      Keywords,
      CrawlerRoutes,
      SerpRoutes,
      TrafficRoutes,
      OverviewRoutes,
      HomeRoutes,
      AuditRoutes,
      OptimizeRoutes,
      CreateRoutes,
      ReviewRoutes,
      ReviewChangesRoutes,
      AuthenticationRoutes,
      LogInRoutes,
      SignupRoutes,
      PdfEditorRoutes,
      KeysRoutes,
      LeadsRoutes,
      PagesRoutes,
      DashboardRoutes,
      SettingsRoutes,
      SubscriptionRoutes,
      GARoutes,
      GSCRoutes,
      FBRoutes,
      AssistantRoutes,
      AccountRoutes,
      PaymentRoutes,
      CancelPlanRoutes,
      PricingRoutes,
      PastdueRoutes,
      SuspiciousRoutes,
      TrialEnded,
      ShopifyRoutes,
      IntegrationWebflowRoutes,
      IntegrationDudaRoutes,
      CompleteSubscriptionRoutes,
      NotFound
    ]
  }
]);
